module.exports = __webpack_public_path__ + "58720a7781b50df959cd3910b468e57a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/plan-banner.jpg
// module id = 447
// module chunks = 0